import { SessionState } from "@idw-types/state/session-state";
import { SessionActionTypes, SessionActions } from "../actions/session-actions";

export const initialSessionState: SessionState = {
    isLoading: false,
    session: null,
    requestCount: 0
};

export const sessionReducer = (
    state: SessionState = initialSessionState,
    action: SessionActions
): SessionState => {
    switch(action.type) {
        case SessionActionTypes.SET_SESSION_LOADING:
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        case SessionActionTypes.SET_SESSION:
            return {
                ...state,
                isLoading: false,
                session: action.payload.session
            };
        case SessionActionTypes.INCREMENT_REQUEST_COUNT:
            return {
                 ...state,
                requestCount: state.requestCount+1
            };
        default:
            return state;
    }
};